import * as api from '../../api';
import { participantTypeHelpers } from '../../participant-types';

const fetchSiteSettingsActions = api.fetchActions('touchpoint-settings', 'fetch-settings');
const submitSiteSettingsActions = api.fetchActions('touchpoint-settings', 'submit-settings');

export const actionTypes = {
  ...fetchSiteSettingsActions.actionTypes,
  UPDATE_ALIAS: 'touchpoint-settings.update-alias',
  ...submitSiteSettingsActions.actionTypes,
}

function shouldFetchSettings(state, siteId, formId)
{
  const { formSettings } = state;
  var siteSettingsState = formSettings.getIn(['settings', siteId, formId]);
  const { isFetching, isValid } = siteSettingsState || {};
  return !siteSettingsState || !(isFetching || isValid);
}

export function fetchSettings(siteId, formId) {
  return (dispatch, getState) => {
    const state = getState();
    if(shouldFetchSettings(state, siteId, formId)) {
      const params = {
        participantTypeId: participantTypeHelpers.getParticipantTypeId(),
        siteId,
        formId
      };

      return dispatch(api.getThunk(`/touchpoint-site-settings`, params, fetchSiteSettingsActions, params));
    }
    else {
      const { formSettings } = state;
      var siteSettingsState = formSettings.getIn(['settings', siteId, formId]);
      return Promise.resolve(siteSettingsState.data);
    }
  }
}

export function updateAlias(siteId, formId, value)
{
  return {
    type: actionTypes.UPDATE_ALIAS,
    siteId,
    formId,
    value
  }
}

function shouldSubmitSettings(state, siteId)
{
  const { formSettings } = state;
  var submissionState = formSettings.getIn(['settingsSubmission', siteId]);
  const { isSubmitting } = submissionState || {};
  return !submissionState || !isSubmitting;
}

export function submitSettings(siteId) {
  return (dispatch, getState) => {
    const state = getState();
    const { formSettings } = state;
    if(shouldSubmitSettings(state, siteId)) {
      var touchpointSettingResponses = [];
      const responses = formSettings.getIn(['settingsResponses', siteId]);
      responses && responses.forEach((alias, formId) => {
        touchpointSettingResponses.push({
          siteId,
          formId,
          alias
        });
      });

      const request = {
        participantTypeId: participantTypeHelpers.getParticipantTypeId(),
        settings: touchpointSettingResponses,
      }

      return dispatch(api.postThunk(`/touchpoint-site-settings`, request, submitSiteSettingsActions, { siteId }));
    }
    else {
      var submissionState = formSettings.getIn(['settingsSubmission', siteId]);
      return Promise.resolve(submissionState.data);
    }
  }
}
